import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { ColumnProps } from 'antd/lib/table'
import { TableCP } from 'submodules/nerit-framework-ui/common/components/table/TableCP'
import { useRequest } from 'submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest'
import { RequestUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils'
import { NotificationHelper } from 'submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper'
import { FormStateManagerUtils } from 'submodules/nerit-framework-ui/common/form-state-manager/FormStateManagerUtils'
import { IFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/types/IFormStateManager'
import { CollectionControlRequests } from 'submodules/nerit-aquatec-sdk/services/collection-control/CollectionControlRequests'
import { CollectionGridResponseDTO, CollectionGridCellResponseDTO } from 'submodules/nerit-aquatec-sdk/services/collection-control/dtos/responses/CollectionGridResponseDTO'
import { CollectionControlFiltersFormModel } from 'modules/collection-performance/components/collection-control/filters-collection-control/inner/CollectionControlFiltersFormModel'
import { CollectionControlTableUtils } from 'modules/collection-performance/components/collection-control/table-collection-control/inner/CollectionControlTableUtils'
import { ModalCollectionCellCP } from 'modules/collection-performance/components/collection-control/modal-collection-cell/ModalCollectionCellCP'
import { MonthColumnTP, MonthRangeUtils } from 'modules/collection-performance/utils/MonthRangeUtils'

interface ICPProps {
    reloadData: number
    formStateManager: IFormStateManager<CollectionControlFiltersFormModel>
    onLoading: (isLoading: boolean) => void
}

type SelectedCellTP = {
    locationCode: number,
    locationName: string,
    year: number,
    month: number,
    monthLabel: string,
    cell: CollectionGridCellResponseDTO,
}

/**
 * Grade ponto x mes do Controle de Pontos (Tela 3.2).
 */
export function TableCollectionControlCP(props: ICPProps): JSX.Element {

    const [tableData, setTableData] = useState<any[]>()
    const [tableColumns, setTableColumns] = useState<Array<ColumnProps<any>>>()
    const [months, setMonths] = useState<MonthColumnTP[]>([])

    const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
    const [selectedCell, setSelectedCell] = useState<SelectedCellTP>()

    const gridRequest = useRequest<CollectionGridResponseDTO>()
    useEffect(onGridRequestChange, [gridRequest.isAwaiting])
    useEffect(() => props.onLoading(gridRequest.isAwaiting), [gridRequest.isAwaiting])

    useEffect(() => { doSearch() }, [props.reloadData])

    /**
     */
    async function doSearch(): Promise<void> {

        if (!props.reloadData || !await FormStateManagerUtils.validateRequiredFields(props.formStateManager))
            return

        const formValues = props.formStateManager.getFormValues()!
        const monthRange = MonthRangeUtils.fromDateRange(formValues.dateRange)

        if (!monthRange) {
            NotificationHelper.error('Ops!', 'Informe o período.')
            return
        }

        setTableData(undefined)
        setTableColumns(undefined)
        setMonths(MonthRangeUtils.buildMonths(monthRange))

        gridRequest.runRequest(CollectionControlRequests.grid({
            locationCodes: formValues.locationCodes!,
            startYear: monthRange.startYear,
            startMonth: monthRange.startMonth,
            endYear: monthRange.endYear,
            endMonth: monthRange.endMonth,
        }))
    }

    /**
     */
    function onGridRequestChange(): void {

        if (!RequestUtils.isValidRequestReturn(gridRequest, NotificationHelper.DEFAULT_ERROR_GET_MESSAGE))
            return

        const structure = CollectionControlTableUtils.mountTableStructure(
            gridRequest.responseData!,
            months,
            (row, month, cell) => {
                setSelectedCell({
                    locationCode: row.locationCode,
                    locationName: row.locationName,
                    year: month.year,
                    month: month.month,
                    monthLabel: month.label,
                    cell,
                })
                setIsModalVisible(true)
            },
        )

        setTableColumns(structure.columns)
        setTableData(structure.data)
    }

    if (!tableData || !tableColumns)
        return <></>

    return (
        <>
            <TableWrapperSCP>
                <TableCP
                    loading={gridRequest.isAwaiting}
                    data={tableData}
                    columns={tableColumns}
                    bordered={true}
                />
            </TableWrapperSCP>

            {
                !!selectedCell &&
                <ModalCollectionCellCP
                    visible={isModalVisible}
                    locationCode={selectedCell.locationCode}
                    locationName={selectedCell.locationName}
                    year={selectedCell.year}
                    month={selectedCell.month}
                    monthLabel={selectedCell.monthLabel}
                    cell={selectedCell.cell}
                    onCancel={() => setIsModalVisible(false)}
                    onSave={() => {
                        setIsModalVisible(false)
                        doSearch()
                    }}
                />
            }
        </>
    )
}

const TableWrapperSCP = styled.div`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;

    > div {
        flex: 1;
        min-height: 0;
        overflow: auto;
    }

    .ant-table-wrapper {
        padding: 20px;
    }

    thead {
        position: sticky;
        top: 0;
        z-index: 2;
    }

    .fixedColumn {
        background: #fff !important;
        position: sticky;
        left: 0;
        z-index: 1;
    }
`
